import React, { useContext } from 'react';
import { TabContext } from './TabProvider';

const Tabs = () => {
    const { activeTab, setActiveTab, tabs } = useContext(TabContext);
    const activeIndex = tabs.findIndex((t) => t?.title === activeTab?.title);

    const bgByDistance = ['bg-card', 'bg-card/80', 'bg-card/60', 'bg-card/40', 'bg-card/20'];

    const getBgClass = (index) => {
        const distance = Math.abs(index - activeIndex);
        return bgByDistance[Math.min(distance, bgByDistance.length - 1)];
    };

    const activeClass = 'text-accent active font-semibold';
    const inactiveClass = 'hover:text-accent/70 hover:bg-card/95';
    const classCondition = (tab) =>
        activeTab?.title === tab?.title ? activeClass : inactiveClass;

    return (
        <ul className="flex flex-wrap overflow-hidden rounded-tl-xl rounded-tr-xl bg-muted dark:bg-slate-800/90 text-center text-sm font-medium text-muted-foreground">
            {tabs.map((tab, index) => (
                <li
                    className="overflow-hidden rounded-t-xl lg:min-w-40 shadow-sm shadow-slate-300 dark:shadow-slate-900"
                    key={tab?.title}
                >
                    <button
                        aria-current="page"
                        className={`inline-block w-full p-4 ${getBgClass(index)} ${classCondition(tab)}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab?.title}
                    </button>
                </li>
            ))}
        </ul>
    );
};

export default Tabs;
